exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading--with-message[data-v-44238957] {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.lds-ellipsis--with-message[data-v-44238957] {\n  position: relative;\n  margin: 0;\n}", ""]);

// exports
